import React, {useMemo} from "react";
import { useIntl } from 'react-intl';
import Toggle from "@ui-components/Toggle";
import retrieveKColorResponses from "../utils/retrieveKColorResponses";
import getKColorResultContextKey from "../utils/getKColorResultContextKey";
import AuthenticationService from "@services/AuthenticationService";


const ConfiguratorSurveyKColorOutput = ({
  output,
  context,
  recursiveResponsesIndex,
}) => {

  // hooks
  const intl = useIntl();

  // utils
  const {product, color, productPackage} = retrieveKColorResponses(context?.responses, output, recursiveResponsesIndex);
  const key = getKColorResultContextKey(product, color, productPackage);
  const result = context?.kColorResults?.[key];
  const priceChosen = useMemo(() => {
    return context?.kColorPricesChosen?.[key]?.[output.id]?.chosenPrice || "kerakoll";
  }, [context?.kColorPricesChosen, key, output.id]);
  const hasTintometerPrice = ![undefined, null].includes(result?.price?.tintometer);
  const canViewToggle = !!AuthenticationService.getUserScopes()?.includes("kcolor_tintometer_price:read");

  // If the result is not available or there is no tintometer price, do not render the toggle
  if (!result || !hasTintometerPrice)
    return null;

  return (
    <div className={"flex flex-row gap-x-2 items-center"}>
      <p>{
        !hasTintometerPrice
          ? intl.formatMessage({id: "price", defaultMessage: "Prezzo"})
          : intl.formatMessage({id: "public_price", defaultMessage: "Prezzo di Listino"})
      }</p>
      {canViewToggle && (
        <Toggle
          checked={priceChosen === "tintometer"}
          onChange={() => {
            context.setKColorPricesChosen((prevState) => ({
              // Flip the chosen price between "kerakoll" and "tintometer"
              ...prevState,
              [key]: {
                ...prevState[key],
                [output.id]: {
                  chosenPrice: priceChosen === "tintometer" ? "kerakoll" : "tintometer",
                },
              },
            }));
          }}
          marginCls={""}
        />
      )}
      <p>
        {intl.formatMessage({id: "price_tintometer", defaultMessage: "Prezzo tintometro"})}
      </p>
    </div>
  );

}

export default ConfiguratorSurveyKColorOutput;